// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"480":"impressum","792":"main"}[chunkId] || chunkId) + "." + {"342":"bbf33696","480":"1e65b66f","792":"2c8d21d9"}[chunkId] + ".js";
};